/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Student_MethodInputs */

const en_student_method = /** @type {(inputs: Student_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Method`)
};

const he_student_method = /** @type {(inputs: Student_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אמצעי`)
};

/**
* | output |
* | --- |
* | "Method" |
*
* @param {Student_MethodInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const student_method = /** @type {((inputs?: Student_MethodInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Student_MethodInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_student_method(inputs)
	return he_student_method(inputs)
});